import { el } from 'redom';

import { stringToSVG } from 'utilities';

import './index.scss';

import cropIconString from 'assets/images/crop-icon.svg?raw';

const cropIcon = stringToSVG(cropIconString);

class CropControl {

  constructor(configuration) {

    this.onCrop = configuration.onCrop;

    this.el = el('button.inline-toolbar-button.crop-control-button', {
      type: 'button',
      onclick: this.handleClick.bind(this)
    }, [cropIcon.cloneNode(true)]);

  }

  handleClick(event) {

    this.onCrop();

  }

}

export default CropControl;